export const integrationsQueryKeys = {
  microsoftConnection: (userId: string | null | undefined, orgId: string | null | undefined) =>
    ['integrations', orgId, userId, 'microsoft'] as const,
  serverData: (tablesId?: string, fieldsId?: string, runsId?: string, sourcesId?: string) =>
    ['integrations', 'server-data', tablesId, fieldsId, runsId, sourcesId] as const,
  /** Every read of the configuration and runs, whichever views it came from. */
  serverDataAll: () => ['integrations', 'server-data'] as const,
  /** One of the Overview's totals reads (logic/integrationOverviewTiles.ts). */
  overview: (readKey: string, tableId?: string) =>
    ['integrations', 'overview', readKey, tableId] as const,
  overviewAll: () => ['integrations', 'overview'] as const,
  run: (runsTableId?: string, runId?: string) =>
    ['integrations', 'run', runsTableId, runId] as const,
  recentRuns: (runsTableId?: string, limit?: number) =>
    ['integrations', 'recent-runs', runsTableId, limit] as const,
  runLogs: (logsTableId?: string, runId?: string, status?: string) =>
    ['integrations', 'run-logs', logsTableId, runId, status] as const,
  /** The saved configuration's problems, for the indicators. */
  configProblems: () => ['integrations', 'config-problems'] as const,
  /** What the server says about a draft's changes before they're saved. */
  configValidation: (changesKey: string) =>
    ['integrations', 'config-validation', changesKey] as const,
  /** A source's login and its last test. */
  sourceLogin: (sourceName: string) => ['integrations', 'source-login', sourceName] as const,
}
